import { APP_STORAGE_NAMESPACE } from '../../utils/storageNames'

export interface SmartPilotPreferences { search: boolean }
const defaults: SmartPilotPreferences = { search: false }
const key = (owner: string) => `${APP_STORAGE_NAMESPACE}:dev-smart-pilot:v1:${owner}`

export function readSmartPilotPreferences(owner: string | null): SmartPilotPreferences {
  if (!owner) return defaults
  try {
    const value = JSON.parse(localStorage.getItem(key(owner)) ?? 'null')
    return { search: value?.search === true }
  } catch { return defaults }
}

export function writeSmartPilotPreferences(owner: string, value: SmartPilotPreferences): void {
  localStorage.setItem(key(owner), JSON.stringify({ search: value.search }))
}
